"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.validClipperRecipe = void 0;
const instance_1 = __importDefault(require("./instance"));
const recipe_1 = require("./recipe");
const errorMessageGenerator_1 = require("../utils/errorMessageGenerator");
exports.validClipperRecipe = instance_1.default
    .object({
    name: instance_1.default
        .string()
        .max(recipe_1.RECIPE_NAME_MAX_LENGTH, errorMessageGenerator_1.maxCharactersError(recipe_1.RECIPE_NAME_MAX_LENGTH)),
    pictureUrl: instance_1.default
        .string()
        .max(recipe_1.RECIPE_INSTRUCTIONS_MAX_LENGTH, errorMessageGenerator_1.maxCharactersError(recipe_1.RECIPE_INSTRUCTIONS_MAX_LENGTH)),
    servings: instance_1.default
        .string()
        .max(recipe_1.RECIPE_SERVINGS_MAX_LENGTH, errorMessageGenerator_1.maxCharactersError(recipe_1.RECIPE_SERVINGS_MAX_LENGTH))
        .nullable(true),
    source: instance_1.default
        .string()
        .max(recipe_1.RECIPE_SOURCE_MAX_LENGTH, errorMessageGenerator_1.maxCharactersError(recipe_1.RECIPE_SOURCE_MAX_LENGTH))
        .nullable(true),
    sourceUrl: instance_1.default
        .string()
        .url("Invalid url")
        .max(recipe_1.RECIPE_SOURCE_URL_MAX_LENGTH, errorMessageGenerator_1.maxCharactersError(recipe_1.RECIPE_SOURCE_URL_MAX_LENGTH))
        .nullable(true),
    description: instance_1.default
        .string()
        .max(recipe_1.RECIPE_DESCRIPTION_MAX_LENGTH, errorMessageGenerator_1.maxCharactersError(recipe_1.RECIPE_DESCRIPTION_MAX_LENGTH))
        .nullable(true),
    times: instance_1.default
        .array()
        .of(instance_1.default.object().shape({
        type: instance_1.default.string().required(errorMessageGenerator_1.requiredError),
        hr: instance_1.default
            .number()
            .transform(x => x || 0)
            .typeError("Numbers only")
            .integer("Numbers only")
            .max(10000, "Max is 10000"),
        min: instance_1.default
            .number()
            .transform(x => x || 0)
            .typeError("Numbers only")
            .integer("Numbers only")
            .max(10000, "Max is 10000")
    }))
        .max(3),
    instructions: instance_1.default
        .string()
        .max(recipe_1.RECIPE_INSTRUCTIONS_MAX_LENGTH, errorMessageGenerator_1.maxCharactersError(recipe_1.RECIPE_INSTRUCTIONS_MAX_LENGTH)),
    ingredients: instance_1.default
        .string()
        .max(recipe_1.RECIPE_INSTRUCTIONS_MAX_LENGTH, errorMessageGenerator_1.maxCharactersError(recipe_1.RECIPE_INSTRUCTIONS_MAX_LENGTH))
})
    .noUnknown();
//# sourceMappingURL=clipper.js.map